import { LogLevel } from './log-level';

export abstract class LoggerConfig {
  abstract level: LogLevel;
  abstract logToConsole: boolean;
  abstract logToServer: boolean;
}

export const defaultConfig: LoggerConfig = {
  level: 'LOG',
  logToConsole: true,
  logToServer: false
};
